import { Component, Input, EventEmitter, Output, OnInit, trigger, state, style, transition, animate } from "@angular/core";
import { ConstantService } from "../providers/language.service";
import { LanguageService } from '../providers/lang.service';
import { Http, Response } from '@angular/http';
import { RestApiServices } from '../providers/rest.service';
import { ActivatedRoute, Router, NavigationStart, Params } from '@angular/router';
import { SharedServiceService } from "../shared/shared-service.service";
import { Subscription } from "rxjs/Subscription";
import { count } from "rxjs/operator/count";
import { AfterViewInit } from "@angular/core/src/metadata/lifecycle_hooks";


@Component({
  selector: 'shop',
  templateUrl: './shop.component.html'

})

export class ShopComponent implements OnInit, AfterViewInit {
  
  public active: boolean = false;
  all_dep: string = ""
  category: any;
  categoryName: any = 'All Departments';
  categoryId: any;
  showloading: boolean = false;
  categoryDetails = [];
  showCategories: boolean = true;
  showSubcategories: boolean = false;
  filterStatus: boolean = false;
  public prevClicked: number = -1;
  products = [];
  whenClicked = [false, false];
  count : any;

  public recommended: boolean = true;
  alldepartments:string = ""; allCategories : string = "";
  @Input() result: any = "";
  @Output() updateEmployee = new EventEmitter<any>();
  private subscription: Subscription;

  constructor(public router: Router, private restApi: RestApiServices, 
    private http: Http, private langService: LanguageService, private route: ActivatedRoute, 
     private sharedService: SharedServiceService) {

  }

  ngOnInit() {
  }

  ngAfterViewInit(){

    this.sharedService.filterStatus.subscribe(res => {
      this.filterStatus = res;
    });

    this.sharedService.changeFooterSelected('shop');
    //this.filterStatus = this.sharedService.getFilterStatusFlag();
    

    this.sharedService.categoryDetails.subscribe(data => {
     
      this.alldepartments = data.name;
      this.count = data.count;
      //this.filterStatus = true;
    });
    

    this.sharedService.hideCategories.subscribe(data => {
   
      this.active = false;
      this.filterStatus = true;
    });
   
    //this.active = this.sharedService.getHideCategoriesFlag();
    //this.active = false;
  

    this.sharedService.changeProductsSearchStatus(true);
    this.sharedService.changeBackbuttonStatus(true);  
    this.langService.getJson().subscribe(data => {
      this.setLabels();
    });
  }

 setLabels() {
      this.langService.getLangLabelValue("LblAllDepartments").then(result => {
        this.alldepartments = result;
        this.categoryName = result;
        this.allCategories = result;  
      });;
  }

  isIn = false;   // store state
  toggleState() { // click handler
    let bool = this.isIn;
    this.isIn = bool === false ? true : false;
  }

  hideCategoryMobileView($event) {
    this.active = !this.active;
    this.filterStatus = false;    
    this.setLabels();
    this.count = 0;
  }

  private toggleText: string = "Show";
  private show: boolean = false;

  public onToggle(): void {
    this.show = !this.show;
    this.toggleText = this.show ? "Hide" : "Show";
  }

  headerSelected() {
    this.filterStatus = false;
    this.setLabels();    
    this.sharedService.changeCategoriesStatus(true);
    this.router.navigate(['dashboard/shop/topsales']);
    this.count = 0;
  }

}


// WEBPACK FOOTER //
// ./src/app/shop/shop.component.ts